export type MonthType = "short" | "long";

// Function to format date according to the local timezone
export function formatDate(
    date: Date, // UTC date
    monthType: "short" | "long" = "short", // Enforce type for month
    dayOfWeekType: "short" | "long" | "none" = "none", // New parameter for day of week format
    isUSForm: boolean = false, // Control the order of the date format
    timeZone: string = "UTC", // Add a parameter for the desired time zone
) {
    // Prepare options for toLocaleDateString based on the input parameters
    const options: Intl.DateTimeFormatOptions = {
        day: "2-digit",
        month: monthType,
        year: "numeric",
        ...(dayOfWeekType !== "none" && { weekday: dayOfWeekType }) // Add weekday if not "none"
    };

    // Format the UTC date in the specified time zone
    const formattedDate = new Intl.DateTimeFormat("en-US", {
        ...options,
        timeZone, // Use the provided time zone
    }).format(date);

    // Remove commas
    let resultDate = formattedDate.replace(/,/g, "");

    // Insert a comma after the day of the week if applicable
    if (dayOfWeekType !== "none") {
        resultDate = resultDate.replace(/^(\w+)(\s)/, "$1,$2"); // Add comma after weekday
    }

    // Remove leading zero from the day
    resultDate = resultDate.replace(/\b0(\d+)/, "$1");

    // Adjust date format based on isUSForm flag
    if (!isUSForm) {
        // Swap the day and month if non-US format is required
        resultDate = resultDate.replace(/(\w+),?\s(\d+)/, "$2 $1");
    }

    return resultDate;
}

// Function to format time without timezone conversion. UTC date is input
export const formatTime = (date: Date) => {
    // Get the hours and minutes directly from the UTC date object
    const hours = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const ampm = hours >= 12 ? "PM" : "AM";
    const formattedHours = hours % 12 || 12; // Convert to 12-hour format
    const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes; // Ensure two digits for minutes

    return `${formattedHours}:${formattedMinutes} ${ampm}`;
};

export function capitaliseFirstLetter(string: string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

// Convert date string to date object.
export function parseDateString(dateString: string | undefined): Date | undefined {
    return dateString ? new Date(dateString) : undefined;
}
